<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <!-- <el-form-item label="选项">
                    <el-select v-model="checkType" placeholder="选项" @change="changeOptions">
                        <el-option label="平台" :value="true"></el-option>
                        <el-option label="学校" :value="false"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" clearable placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.type" clearable placeholder="类型">
                        <el-option v-for="item in types" :key="item.optionValue" :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分类">
                    <el-select v-model="form.categoryId" clearable placeholder="分类">
                        <el-option v-for="item in trainCategorys" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="标签">
                    <el-select v-model="form.tagId" clearable placeholder="标签">
                        <el-option
                            v-for="item in trainTags"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <div>
                <el-button type="primary" @click="addChoose()">从总部导入模块</el-button>
                <el-button type="primary" @click="edit({})" v-if="checkType == false">添加训练模块</el-button>
            </div>
        </div>
        <div class="panel_body">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column min-width="180" prop="title" label="题目">
                </el-table-column>
                <el-table-column width="160" label="封面">
                    <template slot-scope="scope">
                        <el-image style="width: 150px; height: 90px" :src="scope.row.imgPath" :lazy="true"
                            :preview-src="scope.row.imgPath" fit="fill"></el-image>
                    </template>
                </el-table-column>

                <el-table-column min-width="120" prop="typeName" label="类型">
                </el-table-column>
                <el-table-column min-width="120" prop="optName" label="语言类型">
                </el-table-column>
                <el-table-column min-width="120" prop="categoryName" label="分类">
                </el-table-column>
                <el-table-column min-width="120" label="标签">
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.tagNames"></tag-group>
                    </template>
                </el-table-column>
                <!--<el-table-column
                    min-width="180"
                    prop="content"
                    label="任务描述" >
                </el-table-column>-->
                <el-table-column min-width="120" label="显示配置">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.configEnable" @change="doConfig(scope.row)"
                            inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" prop="questionCount" label="题目总数">
                </el-table-column>
                <el-table-column min-width="100" prop="commiterCount" label="提交人数">
                </el-table-column>
                <el-table-column min-width="100" prop="difficulty" label="难度">
                </el-table-column>
                <!-- <el-table-column
                    min-width="180"
                    label="阅卷老师" >
                    <template slot-scope="scope">
                        <div class="fx-col fx-center" style="color:#F56C6C">
                            <span v-for="(item, i) in scope.row.teacherList" :key="i" >
                                {{item.userName}}
                            </span>
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" width="260">
                    <template slot-scope="scope">
                        <div class="fx fx-m_between fx-c_center">
                            <el-link type="primary" @click="getQuestion(scope.row)" :underline="false"><i
                                    class="iconfont icon-wenjian font20"></i><b>训练题目管理</b></el-link>
                            <el-link type="primary" @click="edit(scope.row)" v-if="scope.row.institutionId != 1"
                                :underline="false"><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        </div>
                        <div class="fx fx-m_between fx-c_center" v-if="scope.row.institutionId != 1">
                            <el-link type="primary" @click="moduleStatistics(scope.row)" :underline="false"><i
                                    class="iconfont icon-wenjian font20"></i><b>模块分析</b></el-link>
                            <el-popconfirm @onConfirm="del(scope.row)" title="确认删除该题目吗？">
                                <el-link type="danger" slot="reference" :underline="false"><i
                                        class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                            </el-popconfirm>
                        </div>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                :current-page="pager.currentPage" :page-size="pager.pageSize" :total="pager.dataTotal"
                @current-change="pageChange">
            </el-pagination>
        </div>
        <EditDraw v-if="showEdit" @submit="loadData" @close="showEdit=false" :item="editItem"></EditDraw>
        <ChooseModuleDrawer v-if="showChoose" @close="showChoose = false" @submit="loadData"></ChooseModuleDrawer>
    </div>
</template>

<style scoped>

</style>

<script>
    import EditDraw from './TrainModuleEdit';
    import ChooseModuleDrawer from "./ChooseModuleDrawer";
    import {
        mapMutations
    } from 'vuex';
    export default {
        components: {
            EditDraw,
            ChooseModuleDrawer
        },
        props: [
            "attr"
        ],
        data() {
            return {
                checkType: false, //true 是平台 false 是学校
                form: {
                    keywords: "",
                    enable: true,
                    categoryId: "",
                },
                showEdit: false,
                showChoose: false,
                question: false,
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
                trainCategorys: [],
                trainTags: [],
                types: [],
            }

        },
        watch: {
            "form": {
                handler: function(newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations(["openTab"]),
            addChoose() {
                this.showChoose = true;
            },
            getQuestion(item) {
                if (item.type == 1) { //== 1   题
                    this.openTab({
                        funcKey: "school_page_train_question_manage",
                        title: "训练题目管理",
                        allowDuplicate: true,
                        attr: {
                            item: item,
                            checkType: this.checkType,
                            isSelf: true
                        }
                    });
                } else { //操作题类型 任务
                    this.openTab({
                        funcKey: "school_page_train__task_manage",
                        title: "训练题目管理",
                        allowDuplicate: true,
                        attr: {
                            item: item,
                            checkType: this.checkType,
                            isSelf: true
                        }
                    });
                }
            },
            moduleStatistics(item) {
                if (item.type == 1) { //== 1   题
                    this.openTab({
                        funcKey: "school_page_train_avgscore_crrectrate_statistics",
                        title: "训练分析",
                        allowDuplicate: true,
                        attr: {
                            item: item,
                            isSelf: true
                        }
                    });
                } else { //操作题类型 任务
                    this.openTab({
                        funcKey: "school_page_train_opertion_work",
                        title: "训练分析",
                        allowDuplicate: true,
                        attr: {
                            item: item,
                            isSelf: true
                        }
                    });
                }
            },
            edit(item) {
                this.editItem = {
                    ...item
                };
                this.showEdit = true;
            },
            doConfig(item) {
                this.$ajaxGet("/trainConfig/doModule/" + item.configEnable + "-" + item.id);
            },
            loadData() {
                let url = this.checkType == true ? "/trainModule/listByPlatform" : "/trainModule/list";
                this.$ajaxPost(url, {
                    form: this.form,
                    pager: {
                        ...this.pager,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                    this.showChoose = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            del(item) {
                this.$ajaxGet("/trainModule/del/" + item.id, data => {
                    this.loadData();
                })
            },
            loadTrainCategory() {
                this.$ajaxGet("/trainCategory/listOptionByAll/1", (data) => { //listOptionBySchool
                    this.trainCategorys = data.result;
                })
            },
            // loadTrainCategory() {
            //     let url = this.checkType == true ? "/trainCategory/listOption/1" : "/trainCategory/listOptionBySchool/1";
            //     this.$ajaxGet(url, (data) => {
            //          this.trainCategorys = data.result;
            //     })
            // },
            loadTrainTag() {
                let url = this.checkType == true ? "/trainCategory/listOption/2" :
                "/trainCategory/listOptionBySchool/2";
                this.$ajaxGet(url, (data) => {
                    this.trainTags = data.result;
                })
            },
            loadType() {
                this.$ajaxGet("/common/trainModuleType", (data) => {
                    this.types = data.result;
                })
            },
            changeOptions() {
                this.form.categoryId = "";
                this.trainCategorys = [];
                this.loadTrainCategory();
                this.loadData();
            },

        },

        created() {
            this.loadData();
            this.loadTrainCategory();
            //this.loadTrainTag();
            this.loadType();
        }

    }
</script>
